/** The map legend: every layer with a shape and words (never colour alone). Only the layers shown are listed. */
export type LegendKey = "incident" | "critical" | "alert" | "sos" | "refused" | "station" | "appliance" | "hydrant" | "fix" | "candidate" | "pin" | "ward";

const ENTRIES: Record<LegendKey, { label: string; swatch: JSX.Element }> = {
  incident: { label: "Incident (larger = more severe)", swatch: <circle cx="9" cy="9" r="6" className="fer-sw-incident" /> },
  critical: { label: "Critical incident (emergency)", swatch: <circle cx="9" cy="9" r="7" className="fer-sw-critical" /> },
  alert: { label: "Unhandled alert (ring)", swatch: <circle cx="9" cy="9" r="6" className="fer-sw-alert" /> },
  sos: { label: "Unhandled SOS from the app (ring)", swatch: <circle cx="9" cy="9" r="6" className="fer-sw-sos" /> },
  refused: { label: "SOS refused outside the area (coarse square)", swatch: <rect x="3" y="3" width="12" height="12" className="fer-sw-refused" /> },
  station: { label: "Fire station", swatch: <circle cx="9" cy="9" r="6" className="fer-sw-station" /> },
  appliance: { label: "Appliance (label says its status)", swatch: <circle cx="9" cy="9" r="5" className="fer-sw-appliance" /> },
  hydrant: { label: "Hydrant (filled = working)", swatch: <circle cx="9" cy="9" r="4" className="fer-sw-hydrant" /> },
  fix: { label: "Position received (larger = chosen)", swatch: <circle cx="9" cy="9" r="5" className="fer-sw-fix" /> },
  candidate: { label: "Possible duplicate (orange ring)", swatch: <circle cx="9" cy="9" r="7" className="fer-sw-candidate" /> },
  pin: { label: "Pin dropped", swatch: <circle cx="9" cy="9" r="6" className="fer-sw-pin" /> },
  ward: { label: "Ward boundary (dashed)", swatch: <line x1="1" y1="9" x2="17" y2="9" className="fer-sw-ward" /> },
};

/** Floating chips over a map-first page, or (`inline`) tile-grey chips under a map in a page. */
export function Legend({ keys, inline = false }: { keys: readonly LegendKey[]; inline?: boolean }) {
  return (
    <ul className={`fer-legend${inline ? " fer-legend--inline" : ""}`} aria-label="Map legend">
      {keys.map((k) => (
        <li key={k}>
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            {ENTRIES[k].swatch}
          </svg>
          {ENTRIES[k].label}
        </li>
      ))}
    </ul>
  );
}
